import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {PageComponent} from '../../page.component';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {NotificationsInfo} from '../../models/notifications-info.model';

@Component({
  selector: 'mp-edit-notifications',
  templateUrl: 'edit-notifications.component.html',
  styleUrls: ['edit-notifications.component.css']
})
export class EditNotificationsComponent extends PageComponent implements OnInit {

  loading = false;
  key: string;
  state: boolean;

  errKey = false;
  errFailure = false;
  msgSuccess = false;

  constructor(private readonly apiService: ApiService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
    super();

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.key = params.key;
      this.loadData();
    });
  }

  isLightPage(): boolean {
    return true;
  }

  canGoBack(): boolean {
    return false;
  }

  ngOnInit(): void {
  }

  private loadData(): void {
    this.loading = true;

    this.apiService.getNotificationsInfo(this.key).toPromise()
      .then((value: NotificationsInfo) => {
        this.state = value.state;
        this.loading = false;
      }).catch(err => {
      if (err.status === 401) {
        this.errKey = true;
      } else {
        this.errFailure = true;
      }

      this.loading = false;
    });
  }

  public switchState(state: boolean): void {
    if (state === this.state) {
      return;
    }

    this.state = state;

    this.apiService.editNotifications(this.key, state).toPromise().then(value => {
      this.msgSuccess = true;
    }).catch(err => {
      this.errFailure = true;
    });
  }
}
